import axios from "axios";
import { useCallback } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router";
import { configState } from "../lib/State";
import get_cid_url from "../lib/get_cid_url";
import moment from "moment";
import { useRef } from "react";
import { Player } from "@lottiefiles/react-lottie-player";

export default () => {
  const [point, setPoint] = useState([1, 2]);
  const [users, setUsers] = useState([]);
  const [active, setActive] = useState(0);
  // const [reverse, setReverse] = useState(false);
  const cid = get_cid_url();
  const savedCallback = useRef(null);
  const [counter, setCounter] = useState(60);
  const [textNum, setTextNum] = useState(0);
  const [date, setDate] = useState();
  const [text, setText] = useState([
    { id: 0, text: "운동은 하루를 짧게 하지만 인생을 길게 해준다!" },
    { id: 1, text: "의지를 불태우면 지방도 함께 탄다!" },
    { id: 2, text: "오늘의 고통은 내일의 몸매다!" },
    { id: 3, text: "땀은 지방의 눈물입니다!" },
    { id: 4, text: "확찐살!확찐자!확빼자!" },
  ]);

  // Random Text
  const randomText = () => {
    const pastDate = localStorage.getItem("date");
    const date = moment().format("DD");
    if (date === pastDate) return;

    const pastNum = localStorage.getItem("textNum");
    const copyText = pastNum
      ? text.filter((text) => text.id !== +pastNum)
      : [...text];
    const randomNum = Math.floor(Math.random() * copyText.length);
    localStorage.setItem("pastNum", text[randomNum].id);
    localStorage.setItem("date", date);
    setText(copyText);
    setTextNum(randomNum);
  };

  // Get users data
  const getUsers = async () => {
    randomText();
    let result = await axios.post(
      configState.api + "/chart/photo_zone_member",
      { cid }
    );
    if (result.data.success === 1) {
      setUsers(result.data.rows);
    }
    setActive(0);
  };

  // Interval user data reset
  const callback = () => {
    setCounter(counter - 1);
    getDate();
  };
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect(() => {
    getUsers();
    getDate();
    function tick() {
      savedCallback.current();
    }
    const interval = setInterval(tick, 1000);
    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    if (counter >= 1) return;
    getUsers();
    setCounter(60);
  }, [counter]);
  // 클릭시 새로고침 시간 초기화
  const usersRefreshTimeReset = () => {
    setCounter(60);
  };

  const getDate = () => {
    const options = {
      weekday: "short",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      // hour12: false,
    };
    const newDate = new Date().toLocaleString("ko-kr", options);
    setDate(newDate);
  };

  useEffect(() => {
    if (cid !== "XXXXX" /*줌*/) return;
    document.body.style.zoom = 1;
  }, []);

  return (
    <div
      className={`w-screen h-screen bg-black text-white box-border p-10 flex flex-col items-center justify-between font-[text] `}
    >
      {/* 뒤집기 버튼 */}
      <div
        className={`w-[3.5rem] absolute top-[4rem] right-[5rem]`}
        onClick={() => window.location.reload()}
      >
        <img src="/img/kiosk/reverse.svg" alt="" />
      </div>
      {/* 상단 로고 */}
      <div className="w-3/5 absolute top-[4rem] bg-black">
        <img src="/img/kiosk/logo.svg" alt="" />
      </div>
      {/* 중단 라인 박스 */}
      <div className="border-[5px] w-full flex flex-col items-center mt-[7rem] pt-[4rem] px-10 flex-1">
        {/* 운동완료 텍스트 */}
        <div className="inline-block text-7xl skew-x-[-6deg] skew-y-[-6deg] maintext mt-[6rem] mb-[6rem] text-center">
          {users.length !== 0 && (
            <p
              className={`font-[name] text-[${
                users[active] && users[active].mb_name.length === 4 ? 5 : 7
                // users[active] && 50
              }rem]`}
            >
              <span className="text-[10rem]">{users[active]?.mb_name}</span>{" "}
              회원님
            </p>
          )}
          <p
            className={`font-[name] ${
              users.length === 0 && "text-[6rem] my-[10rem]"
            }`}
          >
            <span className={users.length === 0 ? "text-[8rem]" : null}>
              오
            </span>
            늘도{" "}
            <span className={users.length === 0 ? "text-[8rem]" : null}>
              운
            </span>
            동{" "}
            <span className={users.length === 0 ? "text-[8rem]" : null}>
              완
            </span>
            료!
          </p>
        </div>

        {/* 시간 */}
        <div
          className="text-[4rem] text-center font-[TmonMonsori] font-bold tracking-tighter bg-white text-black w-full mb-7 py-2 rounded-3xl"
          dangerouslySetInnerHTML={{ __html: date }}
        />

        {/* 포인트 */}
        <div className="flex w-full justify-around border-4 py-10 rounded-3xl relative">
          {point.map((point, key) => (
            <div
              key={key}
              className={`flex flex-col items-center w-1/2 ${
                key === 1 && "border-l-4"
              }`}
            >
              <div className="w-1/2 aspect-square flex items-center justify-center [&>.lf-player-container]:w-full">
                {
                  <Player
                    src={`/animation/${key === 0 ? "heart" : "fire"}.json`}
                    autoplay
                    loop
                    className="w-full h-full"
                  />
                }
                {/* <img
                  src={`/img/kiosk/${key === 0 ? "heart.svg" : "fire.svg"}`}
                  alt=""
                /> */}
              </div>
              <div className="text-center">
                <p className="text-4xl font-bold mb-5">
                  {key === 0 ? "누적 심박 포인트" : "누적 칼로리 포인트"}
                </p>
                <p className="text-9xl text-[#FFF100]">
                  {users[active]
                    ? (key === 0
                        ? users[active].point_heart
                          ? users[active].point_heart
                          : 0
                        : users[active].point_kcal
                        ? users[active].point_kcal
                        : 0
                      )?.toLocaleString()
                    : 0}
                </p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-[2.5rem] mt-4 font-[apple] font-bold">
          <p>#오운완 #두써킷 #심박포인트 #칼로리포인트</p>
        </div>
        {/* 랜덤 문구 */}
        <div className="text-[4rem] font-[TmonMonsori] my-[3rem]">
          <p
            className={`text-[${
              +(100 / text[textNum].text.length).toFixed(2) + 0.5
            }vw]`}
          >
            {text[textNum].text}
          </p>
        </div>
      </div>

      {/* 회원선택 */}
      <div className="w-full grid grid-cols-4 grid-rows-4 h-full pt-5 gap-2">
        {users.map((user, key) => (
          <div
            key={key}
            className={`w-full border-4 flex justify-center items-center text-4xl ${
              active === key && "bg-white text-black"
            }`}
            onClick={() => {
              setActive(key);
              usersRefreshTimeReset();
            }}
          >
            <p>{user.mb_name}</p>
          </div>
        ))}
      </div>

      <style jsx="true">{`
        @font-face {
          font-family: "name";
          src: url("/font/RixCrossRoadR.woff");
        }
        @font-face {
          font-family: "text";
          src: url("/font/BebasNeue-Regular.woff");
        }
        @font-fase {
          font-family: "apple"
          src: url("/font/AppleSDGothicNeoSB.woff");
        }
        @font-face {
          font-family: "TmonMonsori";
          src: url("https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_two@1.0/TmonMonsori.woff")
            format("woff");
          font-weight: normal;
          font-style: normal;
        }
        .maintext p:nth-child(2) {
          font-size: 4.5rem;
          margin-top: 2rem;
        }
        .maintext p:nth-child(2) span {
          font-size: 7rem;
        }
        .maintext span {
          color: #ff8e01;
        }
      `}</style>
    </div>
  );
};
